import { render } from "./indexPublicAreaComponent.vue?vue&type=template&id=e4fb384e"
import script from "./indexPublicAreaComponent.vue?vue&type=script&lang=js"
export * from "./indexPublicAreaComponent.vue?vue&type=script&lang=js"

import "@vueform/slider/themes/default.css?vue&type=style&index=0&lang=css"
import "./indexPublicAreaComponent.vue?vue&type=style&index=1&id=e4fb384e&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__